module.exports = __webpack_public_path__ + "static/media/fly0094.06f083b2.webp";